import { render, staticRenderFns } from "./baseConfirm.vue?vue&type=template&id=12e404a9"
import script from "./baseConfirm.vue?vue&type=script&lang=js"
export * from "./baseConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports